export default {
  label: {
    selectFile: 'Select File',
    noSelectFile: 'No file is selected',
    companyInfo: 'Page1',
    employeeCompanyInfo: 'Employee Page 1',
    teamInfo: 'Page2',
    employeeTeamInfo: 'Employee Page 2',
    pageDisplayedName: 'Page/Button Title',
    aboutUs: 'About Us',
    aboutTeam: 'About Team',
    addPicture: 'Add picture',
    modifyPicture: 'Edit Picture',
    modifyPictureOrVideo: 'Edit Picture/Video',
    labelCompanyName: 'Company Name',
    labelSlogan: 'Byline / Slogan',
    delete: 'Delete',
    dragToOrder: 'Drag to Re-Order',
    sureToDelete: 'Are you sure you want to delete this section?',
    groupTitle: 'Title',
    pleaseInputText: 'Enter text here.',
    didNotInputText: 'Oops! Text is required.',
    textDescription: 'Enter description',
    pleaseInputLink: 'Please type URL',
    addGroupPicture: 'Add picture',
    suggestUploadPicture: '750 x 300px recommended  ',
    suggestUploadHeaderPicture: '750 x 360px recommended. Only mp4 video up to 10MB is supported',
    atLeastUploadOnrPicture: 'Please load at least one picture',
    addPictureWallPicture: 'Add a picture board',
    pictureWillDisplayFlat: 'Picture will be placed in one line. 300 x 300px recommended',
    addVideoCover: 'Add \'cover\' image',
    suggestVideoSize: '640 x 480px recommended',
    addVideo: 'Add video',
    suggestVideoSizeAndLength: 'Suggest to upload 640*480 video. 1 min is preferred.',
    playVideo: 'Play',
    addText: 'Add a \'text\' section',
    addLoopPicture: 'Add a \'slide show\' section',
    addCombinationPicture: 'Add a \'picture board\' section',
    addVideoSection: 'Add a \'video\' section',
    text: 'Text',
    loopPicture: 'Slide Show',
    combinationPicture: 'Picture Board',
    videoSection: 'Video',
    add: 'Add new section',
    cancel: 'Cancel',
    preview: 'Preview',
    save: 'Save',
    viewJobs: 'View Jobs',
    team: 'View Jobs',
    headerIsEmpty: 'Oops! Please upload your header image. ',
    msgImageBoard: 'You can add 1-3 images in this section.',
    msgSliderBoard: 'You can add 1-7 images in this section.',
    msgNoUploadImage: 'Oops! It seems you may have forgotten to upload an image. Please check.',
    msgNoCover: 'Oops! Please add a \'cover\' image.',
    msgNoVideo: 'Oops! Please upload your video.',
    msgSaveSuccess: 'Successfully saved.',
    msgSaveErr: 'Oops! An error has occurred. Please try again.',
    msgInputMenuName: 'Oops! Please input your page/button title.',
    textIsEmpty: 'Oops! Text is required.',
    expand: 'Expand',
    collapse: 'Collapse',
    setPageError: 'Please configure Page 1 firstly.',
    setEmployeePageError: 'Please configure Employee Page 1 firstly.',
    wechatShareJobList: 'Job List Page',
    wechatShareJobDetail: 'Job Detail Page',
    wechatShareLogo: 'WeChat Share Icon',
    wechatShareUploadLogo: 'Upload Logo',
    wechatShareTitle: 'Send To Chat Title',
    wechatShareDesc: 'Send To Chat Content',
    wechatShareMomentTitle: 'Share On Moments Title',
    wechatShareSettings: 'WeChat Share Settings',
    tipMessage: 'You can set up the content of WeChat sharing here. The sharing icon should not be smaller than 300px x 300px; and you can use the placeholder #COMPANYNAME# to replace the properties of company automatically inner the sharing content.',
    tipMessageForJobDetail: 'You can set up the content of WeChat sharing here. The sharing icon should not be smaller than 300px x 300px; and you can use the placeholders: #JOBTITLE#, #JOBLOCATION# and #COMPANYNAME# to replace the properties of job or company automatically inner the sharing content.',
    jdSalary: 'Salary',
    jobTitle: 'Job Title',
    jdRoleType: 'Role Type',
    jdExperience: 'Experience',
    jdWorkTime: 'Work Time',
    jdWorkLocation: 'Work Location',
    jobDetailDescription: 'Your Job Description',
    notSpecified: 'Not Specified',
    jobDescTitle: 'Job Description Customization',
    isActivatedLabel: 'Is Activated',
    yes: 'Yes',
    no: 'No',
    isActivatedPage2Msg: 'The configuration is only effective when "Page1" is activated.',
    isActivatedPage6Msg: 'The configuration is only effective when "Employee Page 1" is activated.',
    landingPageSettings: 'Page Settings',
    ON: 'ON',
    OFF: 'OFF',
    jobFilter: 'Job List Filter',
    operation: 'Operation',
    sort: 'Sort',
    jobListFilter: 'Custom Job List Filter',
    mobile: 'Mobile Web',
    pc: 'PC Web',
    editCompanyPage: 'Landing Page Management',
    videoNavigation: 'Video Library',
    customJDDetailFieldTitle: 'Set the field(s) displayed in Job Detail Page',
    customJDDetailFieldHeader: 'The field(s) displayed in Job Detail Page',
    buttonSettingsTitle: 'Button Settings',
    buttonSettingsLabel: 'Button Name',
    buttonOperation: 'Visible on JD page',
    moduleGap: 'Section spacing'
  },
  placeholder: {
  },
  message: {
    filterCountLimitTip: 'Oops! You can only select up to {count} filters in job list page.',
    wrongPhotoFileType: 'Please make sure image type is jpeg or jpg or png or gif',
    wrongHeaderFileType: 'Please make sure file type is jpeg or jpg or png or gif or mp4',
    wrongHeaderVideoFileSize: 'Please make sure video size is no more than {fileSize}MB'
  }
}
